// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import MyHttp from '@/config/myHttp'

import "@/assets/css/common.scss";

/************* 三方组件库 ****************/

/* 引入element-ui*/
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
//定义全局的md5
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

Vue.prototype.$process = process.env;   //引入自定义页面配置文件
Vue.prototype.$common = require('@/config/mUtils.js');    //公共方法
Vue.prototype.$status = require('../statusConfig');//状态配置
Vue.prototype.$mValidate = require('@/config/mValidate.js');    //验证方法调用接口
const province = require('../provinceCity');  //选择省份构造
Vue.prototype.$province = province['provinces'];
import MyLog from '@/config/myLog.js'
Vue.prototype.$log = function (str) {
  MyLog.log(str);
};

/* 公共方法 */
Vue.prototype.$httpPost = function (op) {
  let v = new Vue();
  return new Promise((rs) => {
    if (store.state.user && store.state.user.token) {
      op.reqdata.token = store.state.user.token
    }
    MyHttp.$post(op).then(res => {
      if (res.data.rst === 301) { //如果session过期的时候，返回303错误
        this.$router.push({ path: "/login" });
        this.$requestloading().close();
        rs([null, null]);
        return this.$message({ message: `长时间未操作，需要重新登录`, type: 'error' });
      }
      if (res.data.rst == 300 && res.data.msg.indexOf('org') > -1) {
        return rs(['数据返回错误', null]);
      }
      rs([null, res.data]);
    }).catch(err => {
      rs(['网络异常，请稍后再试！', null]);
    })
  });
};

//字符串去除空格
Vue.prototype.$rmEmp = function (label, val, form) {
  if (typeof (val) === "number") {
    return;
  }
  if (JSON.stringify(form) === '{}') return;
  if (!form[label]) return;
  form[label] = val.replace(/\s*/g, "").replace(/[\uFF00-\uFFFF]/g, "");   //禁用全角输入，如果有输入会被替换(注意不能输入';')
};
Vue.prototype.$requestloading = function (text) {
  return this.$loading({
    //target: document.querySelector('.testLoading'),
    lock: true,
    text: text ? text : 'Loading',
    spinner: 'el-icon-loading',
    background: 'rgba(255, 255, 255, 0.8)'
  });
};

import Print from 'vue-print-nb';
Vue.use(Print);  //注册打印

/*时间转换成yyyy-mm-dd*/
Vue.prototype.$DataTypeChang = function (time, type) {
  let data = '';
  let obj = time ? new Date(time) : new Date();
  let year = obj.getFullYear();
  let Month = ("0" + (obj.getMonth() + 1)).slice(-2);
  let day = ("0" + obj.getDate()).slice(-2);
  let hour = ("0" + obj.getHours()).slice(-2);
  let minu = ("0" + obj.getMinutes()).slice(-2);
  let second = ("0" + obj.getSeconds()).slice(-2);
  if (type === 'datetime') {
    data = `${year}-${Month}-${day} ${hour}:${minu}:${second}`;
  } else if (type === 'datetime2') {
    data = `${year}-${Month}-${day} ${hour}:${minu}`;
  } else if (type === 'datetime3') {
    data = `${year}-${Month}-${day} ${hour}`;
  } else {
    data = `${year}-${Month}-${day}`;
  }
  return data;
},

  //重置form验证样式
  Vue.prototype.$clearForm = function (formName) {
    if (this.$refs[formName] !== undefined) {
      this.$refs[formName].clearValidate();
    }
  };
//重置form框架
Vue.prototype.$resetForm = function (formName) {
  if (this.$refs[formName] || this.$refs[formName] !== undefined) {
    this.$refs[formName].resetFields();
  }
};
//判断重复点击
Vue.prototype.$debounce = function (startTime, detime) {
  let _detime = detime ? detime : 1000
  let _time = new Date().getTime() - startTime;
  if (_time < _detime) return [true, new Date().getTime()];
  return [false, new Date().getTime()];
},


  Vue.prototype.$tableLimit = 15;
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js